<template lang="pug">
    .account-management
        settings-page-head
        .settings-account-management-wrapper
            .account-management__wrapper-section
                head-of-settings-section(title="Account Data Settings")
                .settings__form-wrapper
                    .left-form-section
                        .re-inp-box
                            re-input(label="Email" type="email" v-model.trim="$v.fields.email.$model" :validations="validations.email" :v="$v.fields.email" @input="$v.fields.email.$reset")
                    .right-form-section
                        .re-inp-box
                            re-input(label="Phone" type="tel" v-model.trim="$v.fields.phone.$model" :validations="validations.phone" :v="$v.fields.phone" @input="$v.fields.phone.$reset")
            .account-management__wrapper-section
                head-of-settings-section(title="Security")
                .settings__form-wrapper
                    .left-form-section
                        re-input(label="Password" type="password" v-model.trim="$v.fields.password.$model" :validations="validations.password" :v="$v.fields.password" @input="$v.fields.password.$reset")
                    .right-form-section
                        re-input(label="Confirm Password" type="password" v-model.trim="$v.fields.password_confirmation.$model" :validations="validations.password_confirmation" :v="$v.fields.password_confirmation" @input="$v.fields.password_confirmation.$reset")

            .account-management__wrapper-section
                head-of-settings-section(title="Assistants")
                .assistant-form-wrapper(v-for="(assistant, assistantIndex) in fields.assistants" :key="assistant.id")
                    .delete-btn
                        re-button.re-button--primary.re-button--sm.re-button--circle(@click="deleteAssistant(index)")
                            svg-icon(iconId="trash-can")
                    .settings__form-wrapper
                        .left-form-section
                            .re-inp-box
                                re-input(label="Email" :disabled="!assistant.isNew" :readonly="!assistant.isNew"
                                    v-model.trim="$v.fields.assistants.$model[assistantIndex].email"
                                    :validations="validations.assistants.$each.email"
                                    :v="$v.fields.assistants.$each[assistantIndex].email"
                                    @input="$v.fields.assistants.$each[assistantIndex].email.$reset"
                                )
                        .right-form-section
                .account-management__add-section
                    button.account-management__add-button(@click="addNewAssitant")
                        svg-icon(iconId="plus")
                    span Add Assistant

            .account-management__wrapper-section
                head-of-settings-section(title="Notifications")
                .account-management-receive-email
                    .account-management__on-action
                        .account-management__on-action-wrap
                            span.recieve-email__title Receive Notifications to Email
                            span.recieve-email__subtitle Get notifications about new followers, comments and likes.
                        settings-switcher(v-model="fields.subscribe")

            .account-management__wrapper-section(v-if="is2FAEnabled")
                head-of-settings-section(title="Two-Step Authentication")
                .account-management__on-action
                        .account-management__on-action-wrap
                            span.recieve-email__title Verification via SMS
                            span.recieve-email__subtitle This will allow you to verify your identity via SMS as a part of 2 step authentication process
                        settings-switcher(v-model="fields.sms_2fa")

            .account-management__wrapper-section
                head-of-settings-section#card-details-section(title="Card Details")

                div(ref="cardAddingError")
                    re-toast-alert(v-if="cardAddingError" type="danger") {{ cardAddingError }}

                .card-form-wrapper(v-for="(card, index) in cards" :key="card.key")
                    .delete-btn
                        re-button.re-button--primary.re-button--sm.re-button--circle(@click="deleteCard(index)")
                            svg-icon(iconId="trash-can")
                    .settings__form-wrapper(v-if="card.cardRegistrationId")
                        .left-form-section
                        .right-form-section
                            re-checkbox.primary-card-checkbox(:value="primaryCardRegistrationId == card.cardRegistrationId" label="Primary Card" @input="selectPrimaryCard($event, card)")
                    .settings__form-wrapper
                        .left-form-section
                            .re-inp-box
                                re-input(label="First Name" v-model.trim="card.first_name" :disabled="card.cardRegistrationId" :readonly="card.cardRegistrationId")
                        .right-form-section
                            .re-inp-box
                                re-input(label="Last Name" v-model.trim="card.last_name" :disabled="card.cardRegistrationId" :readonly="card.cardRegistrationId")
                    .settings__form-wrapper(v-if="card.cardRegistrationId")
                        .left-form-section
                            .re-inp-box.required
                                re-input(label="Card Number" v-model.trim="card.number" :disabled="true" :readonly="true")
                        .right-form-section
                            .input-card-info-complex
                                .re-inp-box.required
                                    re-input(label="Expiration (MM / YY)" v-model.trim="card.expiration" :disabled="true" :readonly="true")
                                .re-inp-box.required.input-card-cvc
                                    re-input(label="CVC" value="XXX" :disabled="true" :readonly="true")
                .card-form-wrapper(v-if="checkoutId")
                    .settings__form-wrapper
                        #total-processing-form-container(v-once)
                            form(:action="shopperResultUrl" class="paymentWidgets" data-brands="VISA MASTER")

                .account-management__add-section
                    button.account-management__add-button(@click="showAddCardForm")
                        svg-icon(iconId="plus")
                    span Add New Credit Card

            .account-management__wrapper-section
                head-of-settings-section(title="Login Sessions")
                .account-management-sessions
                    .account-management-session(v-for="session in loginSessions")
                        .account-management-session__description
                            span.account-management-session__name {{ session.browser }} {{ session.os }}
                            span.account-management-session__ip {{ session.ip }}
                        .account-management-session__status(v-if="session.active") Active Now
                re-button.re-button--primary.re-button--sm(style="margin-top: 36px;" @click="deleteLoginSessions" :loading="deletingLoginSessions") Close all sessions

            .account-management__wrapper-section
                head-of-settings-section(title="Referrals")
                p Copy and share the referral link below and earn 5% of the GotMeHookd platform fee for each user who registers using your link.
                .settings__form-wrapper
                    .left-form-section
                        .re-inp-box
                            .form-group.re-input.form-field
                                input.form-control(label="Referral link" v-model="referralLink" readonly)
                        .copy-referral-link
                            re-button.re-button--primary.re-button--sm(@click="copyReferralLink") Copy
                            re-toast-alert(v-if="referalLinkCopied" type="info") The referral link is copied

            .account-management__wrapper-section
                head-of-settings-section(title="Account Management")
                .del-account
                    span Delete Account
                    re-button.re-button--primary.re-button--sm(@click="showDeleteAccountModal = true") Delete
                    re-modal.delete-account-modal(v-if="showDeleteAccountModal" container-class="re-modal-sm" @close="showDeleteAccountModal = false")
                        .re-modal-title Delete account
                        .re-modal-content
                            p Are you sure you want to delete your account?
                        .re-modal-buttons
                            re-button.re-button--secondary.re-button--sm(@click="showDeleteAccountModal = false") Cancel
                            re-button.re-button--primary.re-button--sm(@click="deleteAccount" :loading="deletingAccount") Yes

            re-toast-alert(v-if="errorMessageProfile" type="danger") {{ errorMessageProfile }}

            .settings-save-button
                re-button.re-button--primary.re-button--sm(@click="submit" :loading="formSubmitting") Save

</template>

<script>
import ReProfileEdit from 'utils/vue/components/complex/profile/re-profile-edit/script.js'
import { Validators, parseValidations, setValidationRule, parseValidationSetup, sometimesPasswordRules, phoneRuleIfNotEmpty } from 'utils/vue/lib/validations'
import { countries, copyToClipboard } from 'utils/vue/lib/utils'
import { getFirstErrorMessage } from 'utils/vue/services/main'

const VALIDATIONS = {
    email: setValidationRule('fields.email', {
        required: {error: 'Email is required'},
        email: {error: 'Email is not valid'},
    }),
    phone: setValidationRule('fields.phone', {
        phone: {error: 'Invalid phone number', rule: phoneRuleIfNotEmpty}
    }),
    password: setValidationRule('fields.password', sometimesPasswordRules),
    password_confirmation: setValidationRule('fields.password_confirmation', {
        confirmed: {error: 'Confirm Password needs to be same as Password.', rule: Validators.sameAs('password')},
    }),
    assistants: {
        $each: {
            email: {
                required: Validators.required,
                email: Validators.email,
            },
        },
    }
}

export default {
    name: 'gmh-account-edit',

    mixins: [
        ReProfileEdit
    ],

    data() {
        return {
            fields: {
                email: '',
                phone: '',
                password: '',
                password_confirmation: '',
                subscribe: '',
                sms_2fa: '',
                account_holder_name: '',
                account_number: '',
                routing_number: '',
                replace_bank_details: false,
                assistants: [],
            },
            cards: [],
            primaryCardRegistrationId: null,
            loginSessions: [],

            countries: countries.sort((a, b) => ((a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))),

            deletingLoginSessions: false,
            deletingAccount: false,
            showDeleteAccountModal: false,

            checkoutId: null,
            shopperResultUrl: null,
            cardAddingError: null,

            referralLink: null,
            referalLinkCopied: false,

            is2FAEnabled: window.addiesaas.gotmehookd.is_2fa_enabled,
        }
    },

    validations() {
        const fields = parseValidations(VALIDATIONS)
        return {
            fields: {
                ...fields,
                assistants: VALIDATIONS.assistants,
            }
        }
    },

    async created() {
        const currentUrl = new URL(window.location.href)
        this.shopperResultUrl = currentUrl.origin + currentUrl.pathname

        this.referralLink = currentUrl.origin +
            this.$router.resolve({ name: 'registration-page', query: { referral: this.user.id } }).href

        if (this.$route.query.id) {
            await this.addCard(this.$route.query.id)
        }

        this.loadCards()
        this.loadLoginSessions()
    },

    methods: {
        setupFormLocal() {
            this.validations = parseValidationSetup(VALIDATIONS, this)
            this.setupForm(VALIDATIONS, { email: '', phone: '', password: '', password_confirmation: '', assistants: [] })
        },

        hydrateFields(fields) {
            const values = {
                ..._.pick(this.user, ['email']),
                ..._.pick(this.user.meta, ['phone', 'subscribe', 'sms_2fa']),
            }

            _.forOwn(this.fields, (item, key) => {
                if (!_.isNil(values[key])) {
                    this.fields[key] = values[key]
                }
            })

            this.fields.assistants = this.user.assistants.map(x => Object.assign({}, x))

            this.fields.subscribe = !!this.fields.subscribe
            this.fields.sms_2fa = !!this.fields.sms_2fa

            this.primaryCardRegistrationId = this.user.primary_card_registration_id || null
        },

        async submit() {
            this.isSuccessPersonal = null

            this.$v.$touch()

            const cards = this.cards.map(x => x.cardRegistrationId)
            const assistants = this.fields.assistants.map(x => x.email)

            const payload = {
                email: this.fields.email,
                phone: this.fields.phone,
                password: this.fields.password,
                subscribe: this.fields.subscribe,
                sms_2fa: this.fields.sms_2fa,
                primary_card_registration_id: this.primaryCardRegistrationId,
                cards,
                assistants,
            }

            if (await this.changeProfile(payload)) {
                this.fields.assistants = this.user.assistants.map(x => Object.assign({}, x))

                this.isSuccessPersonal = true

                this.$parent.$parent.$refs.scrollElement.scrollTo({ top: 0, behavior: 'smooth' })
            }

            await this.loadCards()
        },

        showAddCardForm() {
            this.$nextTick(() => {
                this.mountTotalProcessing()
            })
        },
        deleteCard(index) {
            this.cards.splice(index, 1);
        },
        selectPrimaryCard(checked, card) {
            this.primaryCardRegistrationId = checked ? card.cardRegistrationId : null
        },
        async addCard(checkoutId) {
            try {
                await axios.post('/api/customer/total-processing/card-registration', {
                    checkout_id: checkoutId
                })
            } catch (e) {
                this.cardAddingError = getFirstErrorMessage(e)
                this.$refs.cardAddingError.scrollIntoView()
            }
        },
        async mountTotalProcessing() {
            const { data } = await axios.post('/api/customer/total-processing/checkout/registration')
            this.checkoutId = data.id

            const wpwlOptionsText = `
                var wpwlOptions = {
                    onReady: function() {
                        $('.wpwl-button-pay').html('Add');
                    },
                    brandDetection: true,
                    brandDetectionType: 'binlist',
                    maskCvv: true,
                }`

            const wpwlOptionsScript = document.createElement('script')
            wpwlOptionsScript.appendChild(document.createTextNode(wpwlOptionsText))
            document.head.appendChild(wpwlOptionsScript)

            const paymentWidgetsScript = document.createElement('script')
            paymentWidgetsScript.setAttribute('src', data.payment_widgets_js_url)
            document.head.appendChild(paymentWidgetsScript)
        },

        async loadCards() {
            const { data: { data } } = await axios.get('/api/customer/total-processing/card-registration')
            this.cards = data.map((cardRegistration, index) => {
                const nameParts = cardRegistration.card_holder.split(' ', 2)
                return {
                    key: index + 1,
                    cardRegistrationId: cardRegistration.id,
                    first_name: nameParts[0],
                    last_name: nameParts[1] || '',
                    number: `XXXX XXXX XXXX ${cardRegistration.card_last4}`,
                    expiration: `${cardRegistration.card_expiry_month} / ${cardRegistration.card_expiry_year % 100}`,
                }
            })
        },

        async loadLoginSessions() {
            const { data: { data } } = await axios.get('/api/user/access-location')
            this.loginSessions = data
        },

        async deleteLoginSessions() {
            this.deletingLoginSessions = true
            await axios.delete('/api/user/access-tokens')
            this.logout()
        },

        async deleteAccount() {
            this.deletingAccount = true
            await axios.delete('/api/user')
            this.logout();
        },

        logout() {
            this.$store.dispatch('logout')
            this.$router.push({ name: 'login-page' })
        },

        scrollToEl(el) {
            this.$parent.$parent.$refs.scrollElement.scrollTo({
                top: document.getElementById(el).scrollHeight,
                behavior: 'smooth'
            })
        },

        copyReferralLink() {
            copyToClipboard(this.referralLink)

            this.referalLinkCopied = true
        },

        addNewAssitant() {
            this.fields.assistants.push({
                id: Date.now(),
                email: '',
                isNew: true,
            })
        },
        deleteAssistant(index) {
            this.fields.assistants.splice(index, 1)
        },
    }
}
</script>
